/* global Highcharts */
(function () {
  'use strict';

  angular.module('wsLrs.services').factory('HighchartsInterface', ['Utils', function (Utils) {
    var assignMethods = Utils.assignMethods;

    // highcharts methods
    var getColorOption = function getColorOption(i) {
      return Highcharts.getOptions().colors[i];
    };
    return assignMethods({}, [['getColorOption', getColorOption]]);
  }]);
})();
